/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Ampli - A strong typed wrapper for your Analytics
 *
 * This file is generated by Amplitude.
 * To update run 'ampli pull browser'
 *
 * Required dependencies: @amplitude/analytics-browser@^1.3.0
 * Tracking Plan Version: 107
 * Build: 1.0.0
 * Runtime: browser:typescript-ampli-v2
 *
 * [View Tracking Plan](https://data.eu.amplitude.com/meinunterricht/meinUnterricht%20tracking%20plan/events/main/latest)
 *
 * [Full Setup Instructions](https://data.eu.amplitude.com/meinunterricht/meinUnterricht%20tracking%20plan/implementation/browser)
 */

import * as amplitude from '@amplitude/analytics-browser';

export type Environment = 'production' | 'development';

export const ApiKey: Record<Environment, string> = {
  production: '422237ff0cd44cdbae18c2b3230951e7',
  development: 'fa5c9de8e2b50299fecde4f839003acf'
};

/**
 * Default Amplitude configuration options. Contains tracking plan information.
 */
export const DefaultConfiguration: BrowserOptions = {
  plan: {
    version: '107',
    branch: 'main',
    source: 'browser',
    versionId: 'b21a3d80-10f1-4588-a743-2d2935803bed'
  },
  ...{
    ingestionMetadata: {
      sourceName: 'browser-typescript-ampli',
      sourceVersion: '2.0.0'
    }
  },
  serverZone: amplitude.Types.ServerZone.EU
};

export interface LoadOptionsBase { disabled?: boolean }

export type LoadOptionsWithEnvironment = LoadOptionsBase & { environment: Environment; client?: { configuration?: BrowserOptions; }; };
export type LoadOptionsWithApiKey = LoadOptionsBase & { client: { apiKey: string; configuration?: BrowserOptions; } };
export type LoadOptionsWithClientInstance = LoadOptionsBase & { client: { instance: BrowserClient; } };

export type LoadOptions = LoadOptionsWithEnvironment | LoadOptionsWithApiKey | LoadOptionsWithClientInstance;

export interface IdentifyProperties {
  /**
   * The class year(s) that the user teaches
   */
  "class year"?: string;
  /**
   * The subject that the user ranked highest in the subject prioritization
   */
  "first subject"?: string;
  /**
   * The license id includes information about subscription type (teacher, ref, school), price, interval (6mo, 12mo, 24mo).
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  "license id"?: number;
  /**
   * When the user was migrated to mU
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  "migrated date"?: number;
  /**
   * the migration cohort the user was from
   */
  "migration cohort"?: string;
  /**
   * From where the user was migrated to mU from
   */
  "migration source"?: string;
  /**
   * The role the user has choosen during onboarding
   */
  role?: string;
  /**
   * The specific school the user is teaching at and found through our school search during onboarding
   */
  "school name"?: string;
  /**
   * The school stage (schulstufe) the user has selected
   */
  "school stage"?: string;
  /**
   * The school stage(s) the user selected (ex: Sek 1, Sek 2)
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  "school stages"?: string[];
  /**
   * The type of school at which the user teaches
   */
  "school type"?: string;
  /**
   * When the user signed up
   */
  "signup date"?: string;
  /**
   * Whether the user signed up using Email or Facebook
   */
  "signup method"?: string;
  /**
   * The German state the user has selected
   */
  state?: string;
  /**
   * The relevant subject(s) that the user selected
   */
  subject?: string;
  /**
   * The teacher type (Ref, Regular)
   */
  "teacher type"?: string;
  /**
   * Whether the user is a free user or has paid for a subscription
   */
  "user type"?: string;
}

export interface AdminRoleGrantedProperties {
  /**
   * **The group id in zuora for this school. Sample value: SM0009**
   */
  "school id": string;
  /**
   * the user id of the teacher being removed
   */
  "teacher user id"?: string;
}

export interface AiAssistantActionPerformedProperties {
  /**
   * The unique ID of a conversation within the AI assistant
   */
  "conversation id": string;
  /**
   * Identifies which AI capability the event relates to, so the same AI event flow can be analyzed across use cases like image generation, text generation, or audio generation.
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  feature?: string[];
  /**
   * The page source where the event was triggered since the event may be triggered on different pages.
   *
   * **Values:** mukibude, reader, text editor
   *
   * Sample values: first screen, second screen, third screen
   */
  "page source"?: string;
  /**
   * The unique ID of a request to an LLM through the AI assistant
   */
  "request id": string;
  /**
   * When a user is performing an action with the received LLM response such as copying the text, regenerating the response, or a new chat is started.
   */
  type?: string;
  /**
   * If the user sends a custom prompt we send the exact message
   */
  "user prompt"?: string;
}

export interface AiAssistantFeedbackSubmittedProperties {
  /**
   * The unique ID of a conversation within the AI assistant
   */
  "conversation id": string;
  /**
   * Identifies which AI capability the event relates to, so the same AI event flow can be analyzed across use cases like image generation, text generation, or audio generation.
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  feature?: string[];
  /**
   * The type of feedback the user gives about an LLM response; either trough thumbs-up/down (sentiment) or written
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | sentiment, written |
   */
  "feedback type"?: "sentiment" | "written";
  /**
   * Positive or negative feedback of an LLM response
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | positive, negative |
   */
  "feedback value"?: "positive" | "negative";
  /**
   * If the user used a prompt template we send the exact template
   */
  "prompt template"?: string;
  /**
   * A template (predefined) prompt or a custom user prompt/message
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | template, custom |
   */
  "prompt type": "template" | "custom";
  /**
   * The unique ID of a request to an LLM through the AI assistant
   */
  "request id": string;
  /**
   * If the user sends a custom prompt we send the exact message
   */
  "user prompt"?: string;
}

export interface AiAssistantFileUploadedProperties {
  /**
   * **csv, xlsx, pdf, etc**
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  "file type"?: string[];
}

export interface AiAssistantOpenedProperties {
  /**
   * Object array that contains all content event properties
   */
  content?: any[];
  /**
   * The page source where the event was triggered since the event may be triggered on different pages.
   *
   * **Values:** mukibude, reader, text editor
   *
   * Sample values: first screen, second screen, third screen
   */
  "page source"?: string;
}

export interface AiAssistantPastChatOpenedProperties {
  /**
   * Object array that contains all content event properties
   */
  content?: any[];
  /**
   * The unique ID of a conversation within the AI assistant
   */
  "conversation id": string;
  /**
   * The page source where the event was triggered since the event may be triggered on different pages.
   *
   * **Values:** mukibude, reader, text editor
   *
   * Sample values: first screen, second screen, third screen
   */
  "page source"?: string;
}

export interface AiAssistantRequestSentProperties {
  /**
   * Object array that contains all content event properties
   */
  content?: any[];
  /**
   * The unique ID of a conversation within the AI assistant
   */
  "conversation id": string;
  /**
   * **csv, xlsx, pdf, etc**
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  "file type"?: string[];
  /**
   * The user flow the user followed to create a request
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | with unit, from scratch, from welcome screen |
   */
  "flow type"?: "with unit" | "from scratch" | "from welcome screen";
  /**
   * Amount of pages that were selected to export a set or send together with an ai request
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  "page amount"?: number;
  /**
   * The page source where the event was triggered since the event may be triggered on different pages.
   *
   * **Values:** mukibude, reader, text editor
   *
   * Sample values: first screen, second screen, third screen
   */
  "page source"?: string;
  /**
   * If the user used a prompt template we send the exact template
   */
  "prompt template"?: string;
  /**
   * A template (predefined) prompt or a custom user prompt/message
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | template, custom |
   */
  "prompt type": "template" | "custom";
  /**
   * The unique ID of a request to an LLM through the AI assistant
   */
  "request id": string;
  /**
   * A unique search id created with every search
   */
  "search id"?: string;
  "template parameters"?: any[];
  /**
   * If the user sends a custom prompt we send the exact message
   */
  "user prompt"?: string;
}

export interface AiAssistantResponseReceivedProperties {
  /**
   * Object array that contains all content event properties
   */
  content?: any[];
  /**
   * The unique ID of a conversation within the AI assistant
   */
  "conversation id": string;
  /**
   * Identifies which AI capability the event relates to, so the same AI event flow can be analyzed across use cases like image generation, text generation, or audio generation.
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  feature?: string[];
  /**
   * The page source where the event was triggered since the event may be triggered on different pages.
   *
   * **Values:** mukibude, reader, text editor
   *
   * Sample values: first screen, second screen, third screen
   */
  "page source"?: string;
  /**
   * The unique ID of a request to an LLM through the AI assistant
   */
  "request id": string;
}

export interface AiAssistantSuggestionAppliedProperties {
  /**
   * The type of suggestion the user created
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | learning goal, topic |
   */
  "suggestion type": "learning goal" | "topic";
}

export interface AiAssistantSuggestionGeneratedProperties {
  /**
   * The type of suggestion the user created
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | learning goal, topic |
   */
  "suggestion type": "learning goal" | "topic";
}

export interface CancellationOfferRedeemedProperties {
  /**
   * The campaign the offer was attached to
   */
  campaign?: string;
}

export interface CertificateDownloadedProperties {
  /**
   * Object array that contains all content event properties
   */
  content?: any[];
}

export interface CollectionContentAddedProperties {
  /**
   * Whether the content was used to create a new collection or whether it was added to an existing collection.
   *
   * Sample values: new collection, existing collection
   */
  "collection preexistence": string;
  /**
   * Object array that contains all content event properties
   */
  content?: any[];
  /**
   * A unique search id created with every search
   */
  "search id"?: string;
}

export interface CollectionContentRemovedProperties {
  /**
   * Object array that contains all content event properties
   */
  content?: any[];
}

export interface CollectionContentSelectedProperties {
  /**
   * Object array that contains all content event properties
   */
  content?: any[];
}

export interface CollectionCreatedProperties {
  /**
   * The description of the collection
   *
   * Sample values: This is a collection about environment protection.
   */
  "collection description"?: string;
  /**
   * The unique id of the collection
   */
  "collection id": string;
  /**
   * The title of the collection
   *
   * Sample values: Environment, Mindmaps, Bäume...
   */
  "collection name": string;
  /**
   * The type of school addressed by the collection
   *
   * Sample values: Berufliche Schule, Förderschule / Inklusion, Gesamtschule...
   */
  "collection school type"?: string;
  /**
   * The subject(s) covered by the collection
   *
   * Sample values: Deutsch, Mathematik, Geschichte...
   */
  "collection subjects"?: string;
  /**
   * A unique search id created with every search
   */
  "search id"?: string;
}

export interface CollectionDeletedProperties {
  /**
   * The description of the collection
   *
   * Sample values: This is a collection about environment protection.
   */
  "collection description"?: string;
  /**
   * The unique id of the collection
   */
  "collection id": string;
  /**
   * The title of the collection
   *
   * Sample values: Environment, Mindmaps, Bäume...
   */
  "collection name": string;
  /**
   * The type of school addressed by the collection
   *
   * Sample values: Berufliche Schule, Förderschule / Inklusion, Gesamtschule...
   */
  "collection school type"?: string;
  /**
   * The subject(s) covered by the collection
   *
   * Sample values: Deutsch, Mathematik, Geschichte...
   */
  "collection subjects"?: string;
}

export interface CollectionEditedProperties {
  /**
   * The description of the collection
   *
   * Sample values: This is a collection about environment protection.
   */
  "collection description"?: string;
  /**
   * The unique id of the collection
   */
  "collection id": string;
  /**
   * The title of the collection
   *
   * Sample values: Environment, Mindmaps, Bäume...
   */
  "collection name": string;
  /**
   * The type of school addressed by the collection
   *
   * Sample values: Berufliche Schule, Förderschule / Inklusion, Gesamtschule...
   */
  "collection school type"?: string;
  /**
   * The subject(s) covered by the collection
   *
   * Sample values: Deutsch, Mathematik, Geschichte...
   */
  "collection subjects"?: string;
}

export interface CollectionFollowedProperties {
  /**
   * The description of the collection
   *
   * Sample values: This is a collection about environment protection.
   */
  "collection description"?: string;
  /**
   * The unique id of the collection
   */
  "collection id": string;
  /**
   * The title of the collection
   *
   * Sample values: Environment, Mindmaps, Bäume...
   */
  "collection name": string;
  /**
   * The type of school addressed by the collection
   *
   * Sample values: Berufliche Schule, Förderschule / Inklusion, Gesamtschule...
   */
  "collection school type"?: string;
  /**
   * The subject(s) covered by the collection
   *
   * Sample values: Deutsch, Mathematik, Geschichte...
   */
  "collection subjects"?: string;
}

export interface CollectionUnfollowedProperties {
  /**
   * The description of the collection
   *
   * Sample values: This is a collection about environment protection.
   */
  "collection description"?: string;
  /**
   * The unique id of the collection
   */
  "collection id": string;
  /**
   * The title of the collection
   *
   * Sample values: Environment, Mindmaps, Bäume...
   */
  "collection name": string;
  /**
   * The type of school addressed by the collection
   *
   * Sample values: Berufliche Schule, Förderschule / Inklusion, Gesamtschule...
   */
  "collection school type"?: string;
  /**
   * The subject(s) covered by the collection
   *
   * Sample values: Deutsch, Mathematik, Geschichte...
   */
  "collection subjects"?: string;
}

export interface CollectionViewedProperties {
  /**
   * The description of the collection
   *
   * Sample values: This is a collection about environment protection.
   */
  "collection description"?: string;
  /**
   * The unique id of the collection
   */
  "collection id": string;
  /**
   * The title of the collection
   *
   * Sample values: Environment, Mindmaps, Bäume...
   */
  "collection name": string;
  /**
   * The type of school addressed by the collection
   *
   * Sample values: Berufliche Schule, Förderschule / Inklusion, Gesamtschule...
   */
  "collection school type"?: string;
  /**
   * The subject(s) covered by the collection
   *
   * Sample values: Deutsch, Mathematik, Geschichte...
   */
  "collection subjects"?: string;
  /**
   * The collection type of the collection. Sample values: private, curated
   */
  "collection type": string;
}

export interface ContentDownloadedProperties {
  /**
   * Object array that contains all content event properties
   */
  content?: any[];
  /**
   * At which position was the document in the search result page ranked
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  position: number;
  /**
   * The algorithm we used in the search
   */
  "search algorithm"?: string;
  "search filter": any[];
  /**
   * A unique search id created with every search
   */
  "search id"?: string;
  /**
   * The search term submitted by the user.
   */
  "search term"?: string;
}

export interface ContentFavoriteAddedProperties {
  /**
   * Object array that contains all content event properties
   */
  content?: any[];
  /**
   * A unique search id created with every search
   */
  "search id"?: string;
}

export interface ContentFavoriteRemovedProperties {
  /**
   * Object array that contains all content event properties
   */
  content?: any[];
}

export interface ContentPagesSelectedProperties {
  /**
   * Object array that contains all content event properties
   */
  content?: any[];
  /**
   * Amount of pages that were selected to export a set or send together with an ai request
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  "page amount"?: number;
}

export interface ContentSearchedInsideProperties {
  /**
   * Object array that contains all content event properties
   */
  content?: any[];
  /**
   * The search term submitted by the user.
   */
  "search term"?: string;
}

export interface ContentSharedProperties {
  /**
   * Object array that contains all content event properties
   */
  content?: any[];
}

export interface ContentViewedProperties {
  /**
   * Object array that contains all content event properties
   */
  content?: any[];
  /**
   * When user clicks on any material within the main mU dashboard section
   */
  "dashboard section"?: string;
  /**
   * The page source where the event was triggered since the event may be triggered on different pages.
   *
   * **Values:** mukibude, reader, text editor
   *
   * Sample values: first screen, second screen, third screen
   */
  "page source"?: string;
  /**
   * At which position was the document in the search result page ranked
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  position: number;
  /**
   * The algorithm we used in the search
   */
  "search algorithm"?: string;
  /**
   * A unique search id created with every search
   */
  "search id"?: string;
  /**
   * The search term submitted by the user.
   */
  "search term"?: string;
}

export interface CourseEnrolledProperties {
  /**
   * Object array that contains all content event properties
   */
  content?: any[];
}

export interface ExportButtonClickedProperties {
  /**
   * Object array that contains all content event properties
   */
  content?: any[];
}

export interface ExtraSeatsRequestedProperties {
  /**
   * the current total seats a school has
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  "current total seats": number;
  /**
   * **The group id in zuora for this school. Sample value: SM0009**
   */
  "school id": string;
}

export interface FeatureSearchSubmittedProperties {
  /**
   * The page source where the event was triggered since the event may be triggered on different pages.
   *
   * **Values:** mukibude, reader, text editor
   *
   * Sample values: first screen, second screen, third screen
   */
  "page source"?: string;
  /**
   * The search term submitted by the user.
   */
  "search term"?: string;
}

export interface ImageInsertedProperties {
  /**
   * Identifies which AI capability the event relates to, so the same AI event flow can be analyzed across use cases like image generation, text generation, or audio generation.
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  feature?: string[];
  /**
   * Indicates the origin of the image at the moment it is inserted into the content, distinguishing whether the image was uploaded by the user, generated by AI in the current session, or selected from a previously saved library.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | generated now, uploaded, selected from my content |
   */
  "image source": "generated now" | "uploaded" | "selected from my content";
}

export interface InvoiceDownloadedProperties {
  /**
   * the amount of the invoice
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  amount: number;
  /**
   * the unique id of the invoice
   */
  "invoice id": string;
  /**
   * **The group id in zuora for this school. Sample value: SM0009**
   */
  "school id": string;
  /**
   * All products owned by the school. Sample values:
   *
   *  **mU 360, mU Pro, meine Fortbildung**
   *
   * | Rule | Value |
   * |---|---|
   * | Unique Items | true |
   * | Item Type | string |
   */
  "subscription products": string[];
}

export interface LicenseDasbhoardViewedProperties {
  /**
   * **The group id in zuora for this school. Sample value: SM0009**
   */
  "school id": string;
  /**
   * All products owned by the school. Sample values:
   *
   *  **mU 360, mU Pro, meine Fortbildung**
   *
   * | Rule | Value |
   * |---|---|
   * | Unique Items | true |
   * | Item Type | string |
   */
  "subscription products": string[];
}

export interface MessageDisplayedProperties {
  /**
   * The campaign the offer was attached to
   */
  campaign?: string;
  /**
   * The type of onboarding message that was displayed to the user
   *
   *  (A walkthrough starts at 2 interconnected messages)
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | hint, dialog, walkthrough, banner |
   */
  "message type": "hint" | "dialog" | "walkthrough" | "banner";
  /**
   * Iif message type = walkthrough: the step in the walkthrough the message is attached to
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  "walkthrough step"?: number;
}

export interface PageReadProperties {
  /**
   * Object array that contains all content event properties
   */
  content?: any[];
  /**
   * The page number of the page being read in the document. It’s required to know what pages were read in the document in order to decide when a document is truly read.
   *  Sample values: 1, 2, 3...
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  "page number"?: number;
}

export interface PremiumPlanSelectedProperties {
  /**
   * The license id includes information about subscription type (teacher, ref, school), price, interval (6mo, 12mo, 24mo). Sample values: 41, 132
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  "license id"?: number;
  /**
   * **Public product name of subscription that user applied for**
   *
   * meinUnterricht KI
   *
   * meineFortbildung
   *
   * meinUnterricht Pro
   *
   * meinUnterricht 360
   */
  "product name"?: string;
  /**
   * The subscription interval Sample values: 6mo, 12mo, 24mo
   */
  "subscription interval": string;
  /**
   * Whether the user has signed up for a teacher, ref, or school subscription
   *  Sample values: teacher, ref, school
   */
  "subscription type": string;
}

export interface PricingPlansViewedProperties {
  /**
   * From which previous screen did the user arrive at the "Pricing" screen
   *  Sample values: navigation bar, my account, premium info popup, document overlay, content download, premium content
   */
  "conversion path": string;
}

export interface RoleSelectedProperties {
  /**
   * The role the user has choosen during onboarding
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  role?: string[];
}

export interface SchoolLicenseUpgradeRequestedProperties {
  /**
   * **The group id in zuora for this school. Sample value: SM0009**
   */
  "school id": string;
  /**
   * All products owned by the school. Sample values:
   *
   *  **mU 360, mU Pro, meine Fortbildung**
   *
   * | Rule | Value |
   * |---|---|
   * | Unique Items | true |
   * | Item Type | string |
   */
  "subscription products": string[];
}

export interface SchoolNameSelectedProperties {
  /**
   * The specific school the user is teaching at and found through our school search during onboarding
   */
  "school name"?: string;
}

export interface SchoolStageSelectedProperties {
  /**
   * The school stage (schulstufe) the user has selected
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | Primarstufe, Sekundarstufe I, Sekundarstufe II, Sonstiges |
   */
  "school stage"?: "Primarstufe" | "Sekundarstufe I" | "Sekundarstufe II" | "Sonstiges";
}

export interface SearchCompletedProperties {
  /**
   * Property that indicates if the user is searching/filtering/etc in the library or course section of our platform.
   */
  "app section"?: string;
  /**
   * Number of course results returned for the search term
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  "nr of course search results"?: number;
  /**
   * Number of minditem results returned for the search term
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  "nr of minditem search results"?: number;
  /**
   * Number of product results provided for the search term
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  "nr of product search results"?: number;
  /**
   * Number of video results provided for the search term
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  "nr of video search results"?: number;
  /**
   * Indicates whether the search or downstream content interaction was triggered by clicking a Related Topics chip. Set to `true`when a user clicks a Related Topics chip and the chip reformulates/submits a new search.
   */
  "related topics applied"?: boolean;
  /**
   * Was the Related Topics block shown on this search page?
   */
  "related topics displayed"?: boolean;
  /**
   * The algorithm we used in the search
   */
  "search algorithm"?: string;
  "search filter": any[];
  /**
   * A unique search id created with every search
   */
  "search id"?: string;
  /**
   * The tab in which the search happened.
   *
   * | Rule | Value |
   * |---|---|
   * | Enum Values | document, product, video |
   */
  "search results tab": "document" | "product" | "video";
  /**
   * Indicates whether the final submitted search query was applied by clicking an auto-suggestion.
   */
  "search suggestion applied"?: boolean;
  /**
   * The search term submitted by the user.
   */
  "search term"?: string;
}

export interface SearchFilterAppliedProperties {
  /**
   * Property that indicates if the user is searching/filtering/etc in the library or course section of our platform.
   */
  "app section"?: string;
  /**
   * apply = user applies filters when no filters were active before
   *
   * amend = user changes an existing filter setup
   *
   * clear_all = user removes all active filters
   */
  "filter action"?: string;
  /**
   * Number of minditem results returned for the search term
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  "nr of minditem search results"?: number;
  /**
   * Number of product results provided for the search term
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  "nr of product search results"?: number;
  /**
   * Number of video results provided for the search term
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  "nr of video search results"?: number;
  /**
   * The algorithm we used in the search
   */
  "search algorithm"?: string;
  "search filter": any[];
  /**
   * A unique search id created with every search
   */
  "search id"?: string;
  /**
   * By which criteria the search is sorted by.
   *
   *
   * Example values:
   *
   *
   *  *Relevanz*, *Kürzlich* *hinzugefügt*, *Erscheinungsdatum*, *Beliebtheit*
   */
  "search sorted by"?: string;
  /**
   * The search term submitted by the user.
   */
  "search term"?: string;
}

export interface SearchSubmittedProperties {
  /**
   * Property that indicates if the user is searching/filtering/etc in the library or course section of our platform.
   */
  "app section"?: string;
  /**
   * Number of minditem results returned for the search term
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  "nr of minditem search results"?: number;
  /**
   * Number of product results provided for the search term
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  "nr of product search results"?: number;
  /**
   * Number of video results provided for the search term
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  "nr of video search results"?: number;
  /**
   * Indicates whether the search or downstream content interaction was triggered by clicking a Related Topics chip. Set to `true`when a user clicks a Related Topics chip and the chip reformulates/submits a new search.
   */
  "related topics applied"?: boolean;
  /**
   * The algorithm we used in the search
   */
  "search algorithm"?: string;
  "search filter": any[];
  /**
   * A unique search id created with every search
   */
  "search id"?: string;
  /**
   * By which criteria the search is sorted by.
   *
   *
   * Example values:
   *
   *
   *  *Relevanz*, *Kürzlich* *hinzugefügt*, *Erscheinungsdatum*, *Beliebtheit*
   */
  "search sorted by"?: string;
  /**
   * Indicates whether the final submitted search query was applied by clicking an auto-suggestion.
   */
  "search suggestion applied"?: boolean;
  /**
   * The search term submitted by the user.
   */
  "search term"?: string;
}

export interface StateSelectedProperties {
  /**
   * The German state the user has selected
   */
  state?: string;
}

export interface SubscriptionCancellationSelectedProperties {
  /**
   * The page source where the event was triggered since the event may be triggered on different pages.
   *
   * **Values:** mukibude, reader, text editor
   *
   * Sample values: first screen, second screen, third screen
   */
  "page source"?: string;
  /**
   * Whether the subscription is on trial.
   *  Sample values: yes, no
   */
  trial: string;
  /**
   * When a user is performing an action with the received LLM response such as copying the text, regenerating the response, or a new chat is started.
   */
  type?: string;
}

export interface SubscriptionCancellationViewedProperties {
  /**
   * Whether the subscription is on trial.
   *  Sample values: yes, no
   */
  trial: string;
}

export interface SubscriptionPauseSelectedProperties {
  /**
   * The page source where the event was triggered since the event may be triggered on different pages.
   *
   * **Values:** mukibude, reader, text editor
   *
   * Sample values: first screen, second screen, third screen
   */
  "page source"?: string;
}

export interface SubscriptionPauseSubmittedProperties {
  /**
   * The duration of the pause from the subscription. After that duration, the subscription continues.
   *
   * Sample values: 1mo, 2mo, 3mo
   */
  "pause duration": string;
}

export interface SubscriptionSubmittedProperties {
  /**
   * The billing cycle of the subscription
   *  Sample values: monthly, quarterly, total
   */
  "billing cycle"?: string;
  /**
   * The license id includes information about subscription type (teacher, ref, school), price, interval (6mo, 12mo, 24mo). Sample values: 41, 132
   *
   * | Rule | Value |
   * |---|---|
   * | Type | number |
   */
  "license id"?: number;
  /**
   * The payment method used for the subscription
   *   Sample values: SEPA, credit card, Paypal
   */
  "payment method": string;
  /**
   * The previous license id the user had
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  "previous license id"?: number;
  /**
   * The previous user type the user had
   *
   * | Rule | Value |
   * |---|---|
   * | Type | integer |
   */
  "previous user type"?: number;
  /**
   * The promotion/discount code a user used Sample value: schulstart23
   */
  "promo code": string;
  /**
   * The subscription interval Sample values: 6mo, 12mo, 24mo
   */
  "subscription interval": string;
  /**
   * Whether the user has signed up for a teacher, ref, or school subscription
   *  Sample values: teacher, ref, school
   */
  "subscription type": string;
}

export interface TeacherAddedProperties {
  /**
   * **The group id in zuora for this school. Sample value: SM0009**
   */
  "school id": string;
  /**
   * All products owned by the school. Sample values:
   *
   *  **mU 360, mU Pro, meine Fortbildung**
   *
   * | Rule | Value |
   * |---|---|
   * | Unique Items | true |
   * | Item Type | string |
   */
  "subscription products": string[];
}

export interface TeacherInviteResentProperties {
  /**
   * **The group id in zuora for this school. Sample value: SM0009**
   */
  "school id": string;
  /**
   * the user id of the teacher being removed
   */
  "teacher user id"?: string;
}

export interface TeacherRemovedProperties {
  /**
   * **The group id in zuora for this school. Sample value: SM0009**
   */
  "school id": string;
  /**
   * All products owned by the school. Sample values:
   *
   *  **mU 360, mU Pro, meine Fortbildung**
   *
   * | Rule | Value |
   * |---|---|
   * | Unique Items | true |
   * | Item Type | string |
   */
  "subscription products": string[];
  /**
   * the user id of the teacher being removed
   */
  "teacher user id"?: string;
}

export interface TextEditedProperties {
  /**
   * The unique ID of a conversation within the AI assistant
   */
  "conversation id": string;
  /**
   * The page source where the event was triggered since the event may be triggered on different pages.
   *
   * **Values:** mukibude, reader, text editor
   *
   * Sample values: first screen, second screen, third screen
   */
  "page source"?: string;
}

export interface TextEditorFileExportedProperties {
  /**
   * Object array that contains all content event properties
   */
  content?: any[];
  /**
   * The unique ID of a conversation within the AI assistant
   */
  "conversation id": string;
  "export format"?: string;
  "export type"?: string;
  /**
   * Identifies which AI capability the event relates to, so the same AI event flow can be analyzed across use cases like image generation, text generation, or audio generation.
   *
   * | Rule | Value |
   * |---|---|
   * | Item Type | string |
   */
  feature?: string[];
}

export interface TextEditorOpenedProperties {
  /**
   * The unique ID of a conversation within the AI assistant
   */
  "conversation id": string;
  /**
   * The page source where the event was triggered since the event may be triggered on different pages.
   *
   * **Values:** mukibude, reader, text editor
   *
   * Sample values: first screen, second screen, third screen
   */
  "page source"?: string;
  /**
   * The source of the text editor open. The user either edits an inline message (chat) or a document (document) created by Muki.
   */
  "text source"?: string;
}

export interface VideoUnlockedProperties {
  /**
   * Object array that contains all content event properties
   */
  content?: any[];
}

export class Identify implements BaseEvent {
  event_type = amplitude.Types.SpecialEventType.IDENTIFY;

  constructor(
    public event_properties?: IdentifyProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class AdditionalFiltersDisplayed implements BaseEvent {
  event_type = 'Additional Filters Displayed';
}

export class AdminRoleGranted implements BaseEvent {
  event_type = 'Admin Role Granted';

  constructor(
    public event_properties: AdminRoleGrantedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class AiAssistantActionPerformed implements BaseEvent {
  event_type = 'AI Assistant Action Performed';

  constructor(
    public event_properties: AiAssistantActionPerformedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class AiAssistantFeedbackSubmitted implements BaseEvent {
  event_type = 'AI Assistant Feedback Submitted';

  constructor(
    public event_properties: AiAssistantFeedbackSubmittedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class AiAssistantFileUploaded implements BaseEvent {
  event_type = 'AI Assistant File Uploaded';

  constructor(
    public event_properties?: AiAssistantFileUploadedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class AiAssistantOpened implements BaseEvent {
  event_type = 'AI Assistant Opened';

  constructor(
    public event_properties?: AiAssistantOpenedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class AiAssistantPastChatOpened implements BaseEvent {
  event_type = 'AI Assistant Past Chat Opened';

  constructor(
    public event_properties: AiAssistantPastChatOpenedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class AiAssistantRequestSent implements BaseEvent {
  event_type = 'AI Assistant Request Sent';

  constructor(
    public event_properties: AiAssistantRequestSentProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class AiAssistantResponseReceived implements BaseEvent {
  event_type = 'AI Assistant Response Received';

  constructor(
    public event_properties: AiAssistantResponseReceivedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class AiAssistantSuggestionApplied implements BaseEvent {
  event_type = 'AI Assistant Suggestion Applied';

  constructor(
    public event_properties: AiAssistantSuggestionAppliedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class AiAssistantSuggestionGenerated implements BaseEvent {
  event_type = 'AI Assistant Suggestion Generated';

  constructor(
    public event_properties: AiAssistantSuggestionGeneratedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class CancellationOfferRedeemed implements BaseEvent {
  event_type = 'Cancellation Offer Redeemed';

  constructor(
    public event_properties?: CancellationOfferRedeemedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class CertificateDownloaded implements BaseEvent {
  event_type = 'Certificate Downloaded';

  constructor(
    public event_properties?: CertificateDownloadedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ClassesSelected implements BaseEvent {
  event_type = 'Classes Selected';
}

export class CollectionContentAdded implements BaseEvent {
  event_type = 'Collection Content Added';

  constructor(
    public event_properties: CollectionContentAddedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class CollectionContentRemoved implements BaseEvent {
  event_type = 'Collection Content Removed';

  constructor(
    public event_properties?: CollectionContentRemovedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class CollectionContentSelected implements BaseEvent {
  event_type = 'Collection Content Selected';

  constructor(
    public event_properties?: CollectionContentSelectedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class CollectionCreated implements BaseEvent {
  event_type = 'Collection Created';

  constructor(
    public event_properties: CollectionCreatedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class CollectionDeleted implements BaseEvent {
  event_type = 'Collection Deleted';

  constructor(
    public event_properties: CollectionDeletedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class CollectionEdited implements BaseEvent {
  event_type = 'Collection Edited';

  constructor(
    public event_properties: CollectionEditedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class CollectionFollowed implements BaseEvent {
  event_type = 'Collection Followed';

  constructor(
    public event_properties: CollectionFollowedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class CollectionUnfollowed implements BaseEvent {
  event_type = 'Collection Unfollowed';

  constructor(
    public event_properties: CollectionUnfollowedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class CollectionViewed implements BaseEvent {
  event_type = 'Collection Viewed';

  constructor(
    public event_properties: CollectionViewedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ContentDownloaded implements BaseEvent {
  event_type = 'Content Downloaded';

  constructor(
    public event_properties: ContentDownloadedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ContentFavoriteAdded implements BaseEvent {
  event_type = 'Content Favorite Added';

  constructor(
    public event_properties?: ContentFavoriteAddedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ContentFavoriteRemoved implements BaseEvent {
  event_type = 'Content Favorite Removed';

  constructor(
    public event_properties?: ContentFavoriteRemovedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ContentPagesSelected implements BaseEvent {
  event_type = 'Content Pages Selected';

  constructor(
    public event_properties?: ContentPagesSelectedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ContentSearchedInside implements BaseEvent {
  event_type = 'Content Searched Inside';

  constructor(
    public event_properties?: ContentSearchedInsideProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ContentShared implements BaseEvent {
  event_type = 'Content Shared';

  constructor(
    public event_properties?: ContentSharedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ContentViewed implements BaseEvent {
  event_type = 'Content Viewed';

  constructor(
    public event_properties: ContentViewedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class CourseEnrolled implements BaseEvent {
  event_type = 'Course Enrolled';

  constructor(
    public event_properties?: CourseEnrolledProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class DashboardViewed implements BaseEvent {
  event_type = 'Dashboard Viewed';
}

export class ExportButtonClicked implements BaseEvent {
  event_type = 'Export Button Clicked';

  constructor(
    public event_properties?: ExportButtonClickedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ExtraSeatsRequested implements BaseEvent {
  event_type = 'Extra Seats Requested';

  constructor(
    public event_properties: ExtraSeatsRequestedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class FeatureSearchSubmitted implements BaseEvent {
  event_type = 'Feature Search Submitted';

  constructor(
    public event_properties?: FeatureSearchSubmittedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ImageInserted implements BaseEvent {
  event_type = 'Image Inserted';

  constructor(
    public event_properties: ImageInsertedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class InvoiceDownloaded implements BaseEvent {
  event_type = 'Invoice Downloaded';

  constructor(
    public event_properties: InvoiceDownloadedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class LicenseDasbhoardViewed implements BaseEvent {
  event_type = 'License Dasbhoard Viewed';

  constructor(
    public event_properties: LicenseDasbhoardViewedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class MessageDisplayed implements BaseEvent {
  event_type = 'Message Displayed';

  constructor(
    public event_properties: MessageDisplayedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class NameAndPasswordSubmitted implements BaseEvent {
  event_type = 'Name and Password Submitted';
}

export class PageRead implements BaseEvent {
  event_type = 'Page Read';

  constructor(
    public event_properties?: PageReadProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PremiumPlanSelected implements BaseEvent {
  event_type = 'Premium Plan Selected';

  constructor(
    public event_properties: PremiumPlanSelectedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class PricingPlansViewed implements BaseEvent {
  event_type = 'Pricing Plans Viewed';

  constructor(
    public event_properties: PricingPlansViewedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class ProfileCreationStarted implements BaseEvent {
  event_type = 'Profile Creation Started';
}

export class RoleSelected implements BaseEvent {
  event_type = 'Role Selected';

  constructor(
    public event_properties?: RoleSelectedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class SchoolLicenseUpgradeRequested implements BaseEvent {
  event_type = 'School License Upgrade Requested';

  constructor(
    public event_properties: SchoolLicenseUpgradeRequestedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class SchoolNameSelected implements BaseEvent {
  event_type = 'School Name Selected';

  constructor(
    public event_properties?: SchoolNameSelectedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class SchoolSelected implements BaseEvent {
  event_type = 'School Selected';
}

export class SchoolStageSelected implements BaseEvent {
  event_type = 'School Stage Selected';

  constructor(
    public event_properties?: SchoolStageSelectedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class SearchCompleted implements BaseEvent {
  event_type = 'Search Completed';

  constructor(
    public event_properties: SearchCompletedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class SearchFilterApplied implements BaseEvent {
  event_type = 'Search Filter Applied';

  constructor(
    public event_properties: SearchFilterAppliedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class SearchSubmitted implements BaseEvent {
  event_type = 'Search Submitted';

  constructor(
    public event_properties: SearchSubmittedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class StateSelected implements BaseEvent {
  event_type = 'State Selected';

  constructor(
    public event_properties?: StateSelectedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class SubjectsClassified implements BaseEvent {
  event_type = 'Subjects Classified';
}

export class SubjectsSelected implements BaseEvent {
  event_type = 'Subjects Selected';
}

export class SubscriptionCancellationSelected implements BaseEvent {
  event_type = 'Subscription Cancellation Selected';

  constructor(
    public event_properties: SubscriptionCancellationSelectedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class SubscriptionCancellationViewed implements BaseEvent {
  event_type = 'Subscription Cancellation Viewed';

  constructor(
    public event_properties: SubscriptionCancellationViewedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class SubscriptionPauseSelected implements BaseEvent {
  event_type = 'Subscription Pause Selected';

  constructor(
    public event_properties?: SubscriptionPauseSelectedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class SubscriptionPauseSubmitted implements BaseEvent {
  event_type = 'Subscription Pause Submitted';

  constructor(
    public event_properties: SubscriptionPauseSubmittedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class SubscriptionSubmitted implements BaseEvent {
  event_type = 'Subscription Submitted';

  constructor(
    public event_properties: SubscriptionSubmittedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class TeacherAdded implements BaseEvent {
  event_type = 'Teacher Added';

  constructor(
    public event_properties: TeacherAddedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class TeacherInviteResent implements BaseEvent {
  event_type = 'Teacher Invite Resent';

  constructor(
    public event_properties: TeacherInviteResentProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class TeacherRemoved implements BaseEvent {
  event_type = 'Teacher Removed';

  constructor(
    public event_properties: TeacherRemovedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class TextEdited implements BaseEvent {
  event_type = 'Text Edited';

  constructor(
    public event_properties: TextEditedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class TextEditorFileExported implements BaseEvent {
  event_type = 'Text Editor File Exported';

  constructor(
    public event_properties: TextEditorFileExportedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class TextEditorOpened implements BaseEvent {
  event_type = 'Text Editor Opened';

  constructor(
    public event_properties: TextEditorOpenedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export class VideoUnlocked implements BaseEvent {
  event_type = 'Video Unlocked';

  constructor(
    public event_properties?: VideoUnlockedProperties,
  ) {
    this.event_properties = event_properties;
  }
}

export type PromiseResult<T> = { promise: Promise<T | void> };

const getVoidPromiseResult = () => ({ promise: Promise.resolve() });

// prettier-ignore
export class Ampli {
  private disabled: boolean = false;
  private amplitude?: BrowserClient;

  get client(): BrowserClient {
    this.isInitializedAndEnabled();
    return this.amplitude!;
  }

  get isLoaded(): boolean {
    return this.amplitude != null;
  }

  private isInitializedAndEnabled(): boolean {
    if (!this.amplitude) {
      console.error('ERROR: Ampli is not yet initialized. Have you called ampli.load() on app start?');
      return false;
    }
    return !this.disabled;
  }

  /**
   * Initialize the Ampli SDK. Call once when your application starts.
   *
   * @param options Configuration options to initialize the Ampli SDK with.
   */
  load(options: LoadOptions): PromiseResult<void> {
    this.disabled = options.disabled ?? false;

    if (this.amplitude) {
      console.warn('WARNING: Ampli is already intialized. Ampli.load() should be called once at application startup.');
      return getVoidPromiseResult();
    }

    let apiKey: string | null = null;
    if (options.client && 'apiKey' in options.client) {
      apiKey = options.client.apiKey;
    } else if ('environment' in options) {
      apiKey = ApiKey[options.environment];
    }

    if (options.client && 'instance' in options.client) {
      this.amplitude = options.client.instance;
    } else if (apiKey) {
      this.amplitude = amplitude.createInstance();
      const configuration = (options.client && 'configuration' in options.client) ? options.client.configuration : {};
      return this.amplitude.init(apiKey, undefined, { ...DefaultConfiguration, ...configuration });
    } else {
      console.error("ERROR: ampli.load() requires 'environment', 'client.apiKey', or 'client.instance'");
    }

    return getVoidPromiseResult();
  }

  /**
   * Identify a user and set user properties.
   *
   * @param userId The user's id.
   * @param properties The user properties.
   * @param options Optional event options.
   */
  identify(
    userId: string | undefined,
    properties?: IdentifyProperties,
    options?: EventOptions,
  ): PromiseResult<Result> {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    if (userId) {
      options = {...options,  user_id: userId};
    }

    const amplitudeIdentify = new amplitude.Identify();
    const eventProperties = properties;
    if (eventProperties != null) {
      for (const [key, value] of Object.entries(eventProperties)) {
        amplitudeIdentify.set(key, value);
      }
    }
    return this.amplitude!.identify(
      amplitudeIdentify,
      options,
    );
  }

 /**
  * Flush the event.
  */
  flush() : PromiseResult<Result> {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    return this.amplitude!.flush();
  }

  /**
   * Track event
   *
   * @param event The event to track.
   * @param options Optional event options.
   */
  track(event: Event, options?: EventOptions): PromiseResult<Result> {
    if (!this.isInitializedAndEnabled()) {
      return getVoidPromiseResult();
    }

    return this.amplitude!.track(event, undefined, options);
  }

  /**
   * Additional Filters Displayed
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/meinunterricht/meinUnterricht%20tracking%20plan/events/main/latest/Additional%20Filters%20Displayed)
   *
   * Event has no description in tracking plan.
   *
   * @param options Amplitude event options.
   */
  additionalFiltersDisplayed(
    options?: EventOptions,
  ) {
    return this.track(new AdditionalFiltersDisplayed(), options);
  }

  /**
   * Admin Role Granted
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/meinunterricht/meinUnterricht%20tracking%20plan/events/main/latest/Admin%20Role%20Granted)
   *
   * When aRecords when administrative privileges are assigned to a user
   *
   * @param properties The event's properties (e.g. school id)
   * @param options Amplitude event options.
   */
  adminRoleGranted(
    properties: AdminRoleGrantedProperties,
    options?: EventOptions,
  ) {
    return this.track(new AdminRoleGranted(properties), options);
  }

  /**
   * AI Assistant Action Performed
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/meinunterricht/meinUnterricht%20tracking%20plan/events/main/latest/AI%20Assistant%20Action%20Performed)
   *
   * Tracks downstream actions taken on an AI-generated image. Triggered when a user downloads, copies, inserts, or regenerates a generated image.
   *
   * @param properties The event's properties (e.g. conversation id)
   * @param options Amplitude event options.
   */
  aiAssistantActionPerformed(
    properties: AiAssistantActionPerformedProperties,
    options?: EventOptions,
  ) {
    return this.track(new AiAssistantActionPerformed(properties), options);
  }

  /**
   * AI Assistant Feedback Submitted
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/meinunterricht/meinUnterricht%20tracking%20plan/events/main/latest/AI%20Assistant%20Feedback%20Submitted)
   *
   * When a user is submitting feedback about the LLM response
   *
   * @param properties The event's properties (e.g. conversation id)
   * @param options Amplitude event options.
   */
  aiAssistantFeedbackSubmitted(
    properties: AiAssistantFeedbackSubmittedProperties,
    options?: EventOptions,
  ) {
    return this.track(new AiAssistantFeedbackSubmitted(properties), options);
  }

  /**
   * AI Assistant File Uploaded
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/meinunterricht/meinUnterricht%20tracking%20plan/events/main/latest/AI%20Assistant%20File%20Uploaded)
   *
   * When a user uploads a file to wok with
   *
   * @param properties The event's properties (e.g. file type)
   * @param options Amplitude event options.
   */
  aiAssistantFileUploaded(
    properties?: AiAssistantFileUploadedProperties,
    options?: EventOptions,
  ) {
    return this.track(new AiAssistantFileUploaded(properties), options);
  }

  /**
   * AI Assistant Opened
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/meinunterricht/meinUnterricht%20tracking%20plan/events/main/latest/AI%20Assistant%20Opened)
   *
   * When a user opens the AI assistant
   *
   * @param properties The event's properties (e.g. content)
   * @param options Amplitude event options.
   */
  aiAssistantOpened(
    properties?: AiAssistantOpenedProperties,
    options?: EventOptions,
  ) {
    return this.track(new AiAssistantOpened(properties), options);
  }

  /**
   * AI Assistant Past Chat Opened
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/meinunterricht/meinUnterricht%20tracking%20plan/events/main/latest/AI%20Assistant%20Past%20Chat%20Opened)
   *
   * When a user opens a chat from their chat history
   *
   * @param properties The event's properties (e.g. content)
   * @param options Amplitude event options.
   */
  aiAssistantPastChatOpened(
    properties: AiAssistantPastChatOpenedProperties,
    options?: EventOptions,
  ) {
    return this.track(new AiAssistantPastChatOpened(properties), options);
  }

  /**
   * AI Assistant Request Sent
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/meinunterricht/meinUnterricht%20tracking%20plan/events/main/latest/AI%20Assistant%20Request%20Sent)
   *
   * When a user requests an output from the assistant
   *
   * @param properties The event's properties (e.g. content)
   * @param options Amplitude event options.
   */
  aiAssistantRequestSent(
    properties: AiAssistantRequestSentProperties,
    options?: EventOptions,
  ) {
    return this.track(new AiAssistantRequestSent(properties), options);
  }

  /**
   * AI Assistant Response Received
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/meinunterricht/meinUnterricht%20tracking%20plan/events/main/latest/AI%20Assistant%20Response%20Received)
   *
   * Identifies which action the user took on the AI-generated image after it was returned.
   *
   * @param properties The event's properties (e.g. content)
   * @param options Amplitude event options.
   */
  aiAssistantResponseReceived(
    properties: AiAssistantResponseReceivedProperties,
    options?: EventOptions,
  ) {
    return this.track(new AiAssistantResponseReceived(properties), options);
  }

  /**
   * AI Assistant Suggestion Applied
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/meinunterricht/meinUnterricht%20tracking%20plan/events/main/latest/AI%20Assistant%20Suggestion%20Applied)
   *
   * When a user selects a topic or learning goal suggestion
   *
   * @param properties The event's properties (e.g. suggestion type)
   * @param options Amplitude event options.
   */
  aiAssistantSuggestionApplied(
    properties: AiAssistantSuggestionAppliedProperties,
    options?: EventOptions,
  ) {
    return this.track(new AiAssistantSuggestionApplied(properties), options);
  }

  /**
   * AI Assistant Suggestion Generated
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/meinunterricht/meinUnterricht%20tracking%20plan/events/main/latest/AI%20Assistant%20Suggestion%20Generated)
   *
   * When a user generates a topic or learning goal suggestion
   *
   * @param properties The event's properties (e.g. suggestion type)
   * @param options Amplitude event options.
   */
  aiAssistantSuggestionGenerated(
    properties: AiAssistantSuggestionGeneratedProperties,
    options?: EventOptions,
  ) {
    return this.track(new AiAssistantSuggestionGenerated(properties), options);
  }

  /**
   * Cancellation Offer Redeemed
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/meinunterricht/meinUnterricht%20tracking%20plan/events/main/latest/Cancellation%20Offer%20Redeemed)
   *
   * When the user redeems a cancellation offer
   *
   * @param properties The event's properties (e.g. campaign)
   * @param options Amplitude event options.
   */
  cancellationOfferRedeemed(
    properties?: CancellationOfferRedeemedProperties,
    options?: EventOptions,
  ) {
    return this.track(new CancellationOfferRedeemed(properties), options);
  }

  /**
   * Certificate Downloaded
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/meinunterricht/meinUnterricht%20tracking%20plan/events/main/latest/Certificate%20Downloaded)
   *
   * Tracks when a user downloads a certificate
   *
   * @param properties The event's properties (e.g. content)
   * @param options Amplitude event options.
   */
  certificateDownloaded(
    properties?: CertificateDownloadedProperties,
    options?: EventOptions,
  ) {
    return this.track(new CertificateDownloaded(properties), options);
  }

  /**
   * Classes Selected
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/meinunterricht/meinUnterricht%20tracking%20plan/events/main/latest/Classes%20Selected)
   *
   * When the user has selected the classes he teaches and provided information on whether he is a ref teacher or not
   *
   * Owner: thomas@kasva.io
   *
   * @param options Amplitude event options.
   */
  classesSelected(
    options?: EventOptions,
  ) {
    return this.track(new ClassesSelected(), options);
  }

  /**
   * Collection Content Added
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/meinunterricht/meinUnterricht%20tracking%20plan/events/main/latest/Collection%20Content%20Added)
   *
   * When a user has successfully added content to a collection.
   *
   * Owner: thomas@kasva.io
   *
   * @param properties The event's properties (e.g. collection preexistence)
   * @param options Amplitude event options.
   */
  collectionContentAdded(
    properties: CollectionContentAddedProperties,
    options?: EventOptions,
  ) {
    return this.track(new CollectionContentAdded(properties), options);
  }

  /**
   * Collection Content Removed
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/meinunterricht/meinUnterricht%20tracking%20plan/events/main/latest/Collection%20Content%20Removed)
   *
   * When a user has removed content from a collection.
   *
   * Owner: thomas@kasva.io
   *
   * @param properties The event's properties (e.g. content)
   * @param options Amplitude event options.
   */
  collectionContentRemoved(
    properties?: CollectionContentRemovedProperties,
    options?: EventOptions,
  ) {
    return this.track(new CollectionContentRemoved(properties), options);
  }

  /**
   * Collection Content Selected
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/meinunterricht/meinUnterricht%20tracking%20plan/events/main/latest/Collection%20Content%20Selected)
   *
   * When a user taps on a button to add content to a collection. The content has not been added to a specific collection yet at this point, the user may still cancel.
   *
   * Owner: thomas@kasva.io
   *
   * @param properties The event's properties (e.g. content)
   * @param options Amplitude event options.
   */
  collectionContentSelected(
    properties?: CollectionContentSelectedProperties,
    options?: EventOptions,
  ) {
    return this.track(new CollectionContentSelected(properties), options);
  }

  /**
   * Collection Created
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/meinunterricht/meinUnterricht%20tracking%20plan/events/main/latest/Collection%20Created)
   *
   * When a user has created a new collection.
   *
   * Owner: thomas@kasva.io
   *
   * @param properties The event's properties (e.g. collection description)
   * @param options Amplitude event options.
   */
  collectionCreated(
    properties: CollectionCreatedProperties,
    options?: EventOptions,
  ) {
    return this.track(new CollectionCreated(properties), options);
  }

  /**
   * Collection Deleted
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/meinunterricht/meinUnterricht%20tracking%20plan/events/main/latest/Collection%20Deleted)
   *
   * When a user has deleted an existing collection.
   *
   * Owner: thomas@kasva.io
   *
   * @param properties The event's properties (e.g. collection description)
   * @param options Amplitude event options.
   */
  collectionDeleted(
    properties: CollectionDeletedProperties,
    options?: EventOptions,
  ) {
    return this.track(new CollectionDeleted(properties), options);
  }

  /**
   * Collection Edited
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/meinunterricht/meinUnterricht%20tracking%20plan/events/main/latest/Collection%20Edited)
   *
   * When a user has edited an existing collection.
   *
   * Owner: thomas@kasva.io
   *
   * @param properties The event's properties (e.g. collection description)
   * @param options Amplitude event options.
   */
  collectionEdited(
    properties: CollectionEditedProperties,
    options?: EventOptions,
  ) {
    return this.track(new CollectionEdited(properties), options);
  }

  /**
   * Collection Followed
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/meinunterricht/meinUnterricht%20tracking%20plan/events/main/latest/Collection%20Followed)
   *
   * When a user has followed a collection.
   *
   * Owner: thomas@kasva.io
   *
   * @param properties The event's properties (e.g. collection description)
   * @param options Amplitude event options.
   */
  collectionFollowed(
    properties: CollectionFollowedProperties,
    options?: EventOptions,
  ) {
    return this.track(new CollectionFollowed(properties), options);
  }

  /**
   * Collection Unfollowed
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/meinunterricht/meinUnterricht%20tracking%20plan/events/main/latest/Collection%20Unfollowed)
   *
   * When a user has unfollowed a collection.
   *
   * Owner: thomas@kasva.io
   *
   * @param properties The event's properties (e.g. collection description)
   * @param options Amplitude event options.
   */
  collectionUnfollowed(
    properties: CollectionUnfollowedProperties,
    options?: EventOptions,
  ) {
    return this.track(new CollectionUnfollowed(properties), options);
  }

  /**
   * Collection Viewed
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/meinunterricht/meinUnterricht%20tracking%20plan/events/main/latest/Collection%20Viewed)
   *
   * When a user had viewed a collection.
   *
   * Owner: thomas@kasva.io
   *
   * @param properties The event's properties (e.g. collection description)
   * @param options Amplitude event options.
   */
  collectionViewed(
    properties: CollectionViewedProperties,
    options?: EventOptions,
  ) {
    return this.track(new CollectionViewed(properties), options);
  }

  /**
   * Content Downloaded
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/meinunterricht/meinUnterricht%20tracking%20plan/events/main/latest/Content%20Downloaded)
   *
   * When the user has downloaded a document (mind item).
   *
   * Owner: thomas@kasva.io
   *
   * @param properties The event's properties (e.g. content)
   * @param options Amplitude event options.
   */
  contentDownloaded(
    properties: ContentDownloadedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ContentDownloaded(properties), options);
  }

  /**
   * Content Favorite Added
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/meinunterricht/meinUnterricht%20tracking%20plan/events/main/latest/Content%20Favorite%20Added)
   *
   * When a user has favorited a content.
   *
   * Owner: thomas@kasva.io
   *
   * @param properties The event's properties (e.g. content)
   * @param options Amplitude event options.
   */
  contentFavoriteAdded(
    properties?: ContentFavoriteAddedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ContentFavoriteAdded(properties), options);
  }

  /**
   * Content Favorite Removed
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/meinunterricht/meinUnterricht%20tracking%20plan/events/main/latest/Content%20Favorite%20Removed)
   *
   * When a user has removed a content from his favorites.
   *
   * Owner: thomas@kasva.io
   *
   * @param properties The event's properties (e.g. content)
   * @param options Amplitude event options.
   */
  contentFavoriteRemoved(
    properties?: ContentFavoriteRemovedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ContentFavoriteRemoved(properties), options);
  }

  /**
   * Content Pages Selected
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/meinunterricht/meinUnterricht%20tracking%20plan/events/main/latest/Content%20Pages%20Selected)
   *
   * Event to track when users select pages in the first step of the export flow. The event is triggered, when the user clicks on "Weiter".
   *
   * @param properties The event's properties (e.g. content)
   * @param options Amplitude event options.
   */
  contentPagesSelected(
    properties?: ContentPagesSelectedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ContentPagesSelected(properties), options);
  }

  /**
   * Content Searched Inside
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/meinunterricht/meinUnterricht%20tracking%20plan/events/main/latest/Content%20Searched%20Inside)
   *
   * When a user searched inside a document
   *
   * @param properties The event's properties (e.g. content)
   * @param options Amplitude event options.
   */
  contentSearchedInside(
    properties?: ContentSearchedInsideProperties,
    options?: EventOptions,
  ) {
    return this.track(new ContentSearchedInside(properties), options);
  }

  /**
   * Content Shared
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/meinunterricht/meinUnterricht%20tracking%20plan/events/main/latest/Content%20Shared)
   *
   * When a user has tapped on the button to share a piece of content. The user may not copy and paste the URL nor actually share the URL.
   *
   * Owner: thomas@kasva.io
   *
   * @param properties The event's properties (e.g. content)
   * @param options Amplitude event options.
   */
  contentShared(
    properties?: ContentSharedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ContentShared(properties), options);
  }

  /**
   * Content Viewed
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/meinunterricht/meinUnterricht%20tracking%20plan/events/main/latest/Content%20Viewed)
   *
   * When the user has viewed any content
   *
   * Owner: thomas@kasva.io
   *
   * @param properties The event's properties (e.g. content)
   * @param options Amplitude event options.
   */
  contentViewed(
    properties: ContentViewedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ContentViewed(properties), options);
  }

  /**
   * Course Enrolled
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/meinunterricht/meinUnterricht%20tracking%20plan/events/main/latest/Course%20Enrolled)
   *
   * Tracks when a user enrolls in a course.
   *
   * @param properties The event's properties (e.g. content)
   * @param options Amplitude event options.
   */
  courseEnrolled(
    properties?: CourseEnrolledProperties,
    options?: EventOptions,
  ) {
    return this.track(new CourseEnrolled(properties), options);
  }

  /**
   * Dashboard Viewed
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/meinunterricht/meinUnterricht%20tracking%20plan/events/main/latest/Dashboard%20Viewed)
   *
   * This event represents a user accessing and viewing the main mU dashboard. It is triggered each time the dashboard screen is fully loaded and displayed to the user.
   *
   * @param options Amplitude event options.
   */
  dashboardViewed(
    options?: EventOptions,
  ) {
    return this.track(new DashboardViewed(), options);
  }

  /**
   * Export Button Clicked
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/meinunterricht/meinUnterricht%20tracking%20plan/events/main/latest/Export%20Button%20Clicked)
   *
   * When a user clicks on the Export CTA to add pages of a mind item to a new or existing Lernset in the reader.
   *
   * @param properties The event's properties (e.g. content)
   * @param options Amplitude event options.
   */
  exportButtonClicked(
    properties?: ExportButtonClickedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ExportButtonClicked(properties), options);
  }

  /**
   * Extra Seats Requested
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/meinunterricht/meinUnterricht%20tracking%20plan/events/main/latest/Extra%20Seats%20Requested)
   *
   * Tracks when a user requests additional seats beyond their current allocation, indicating a need for increased access or licenses.
   *
   * @param properties The event's properties (e.g. current total seats)
   * @param options Amplitude event options.
   */
  extraSeatsRequested(
    properties: ExtraSeatsRequestedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ExtraSeatsRequested(properties), options);
  }

  /**
   * Feature Search Submitted
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/meinunterricht/meinUnterricht%20tracking%20plan/events/main/latest/Feature%20Search%20Submitted)
   *
   * Triggered when a user submits a search query within a workspace to find saved, generated, or user-organized content.
   *
   * @param properties The event's properties (e.g. page source)
   * @param options Amplitude event options.
   */
  featureSearchSubmitted(
    properties?: FeatureSearchSubmittedProperties,
    options?: EventOptions,
  ) {
    return this.track(new FeatureSearchSubmitted(properties), options);
  }

  /**
   * Image Inserted
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/meinunterricht/meinUnterricht%20tracking%20plan/events/main/latest/Image%20Inserted)
   *
   * When an image is successfully inserted into the text editor
   *
   * @param properties The event's properties (e.g. feature)
   * @param options Amplitude event options.
   */
  imageInserted(
    properties: ImageInsertedProperties,
    options?: EventOptions,
  ) {
    return this.track(new ImageInserted(properties), options);
  }

  /**
   * Invoice Downloaded
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/meinunterricht/meinUnterricht%20tracking%20plan/events/main/latest/Invoice%20Downloaded)
   *
   * triggers when a school admin downlaods a copy of an invoice
   *
   * @param properties The event's properties (e.g. amount)
   * @param options Amplitude event options.
   */
  invoiceDownloaded(
    properties: InvoiceDownloadedProperties,
    options?: EventOptions,
  ) {
    return this.track(new InvoiceDownloaded(properties), options);
  }

  /**
   * License Dasbhoard Viewed
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/meinunterricht/meinUnterricht%20tracking%20plan/events/main/latest/License%20Dasbhoard%20Viewed)
   *
   * Indicates when a school administrator accesses the license management dashboard (on page laod) to review license status, usage, and seat allocation details.
   *
   * @param properties The event's properties (e.g. school id)
   * @param options Amplitude event options.
   */
  licenseDasbhoardViewed(
    properties: LicenseDasbhoardViewedProperties,
    options?: EventOptions,
  ) {
    return this.track(new LicenseDasbhoardViewed(properties), options);
  }

  /**
   * Message Displayed
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/meinunterricht/meinUnterricht%20tracking%20plan/events/main/latest/Message%20Displayed)
   *
   * When an onboarding message was displayed to the user
   *
   * @param properties The event's properties (e.g. campaign)
   * @param options Amplitude event options.
   */
  messageDisplayed(
    properties: MessageDisplayedProperties,
    options?: EventOptions,
  ) {
    return this.track(new MessageDisplayed(properties), options);
  }

  /**
   * Name and Password Submitted
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/meinunterricht/meinUnterricht%20tracking%20plan/events/main/latest/Name%20and%20Password%20Submitted)
   *
   * When the user has provided a name and password during profile creation
   *
   * Owner: thomas@kasva.io
   *
   * @param options Amplitude event options.
   */
  nameAndPasswordSubmitted(
    options?: EventOptions,
  ) {
    return this.track(new NameAndPasswordSubmitted(), options);
  }

  /**
   * Page Read
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/meinunterricht/meinUnterricht%20tracking%20plan/events/main/latest/Page%20Read)
   *
   * When the user has been on a page for at least 30 seconds.
   *
   * Owner: thomas@kasva.io
   *
   * @param properties The event's properties (e.g. content)
   * @param options Amplitude event options.
   */
  pageRead(
    properties?: PageReadProperties,
    options?: EventOptions,
  ) {
    return this.track(new PageRead(properties), options);
  }

  /**
   * Premium Plan Selected
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/meinunterricht/meinUnterricht%20tracking%20plan/events/main/latest/Premium%20Plan%20Selected)
   *
   * When a user selects the Premium Plan
   *
   * Owner: thomas@kasva.io
   *
   * @param properties The event's properties (e.g. license id)
   * @param options Amplitude event options.
   */
  premiumPlanSelected(
    properties: PremiumPlanSelectedProperties,
    options?: EventOptions,
  ) {
    return this.track(new PremiumPlanSelected(properties), options);
  }

  /**
   * Pricing Plans Viewed
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/meinunterricht/meinUnterricht%20tracking%20plan/events/main/latest/Pricing%20Plans%20Viewed)
   *
   * When a user views the pricing page
   *
   * Owner: thomas@kasva.io
   *
   * @param properties The event's properties (e.g. conversion path)
   * @param options Amplitude event options.
   */
  pricingPlansViewed(
    properties: PricingPlansViewedProperties,
    options?: EventOptions,
  ) {
    return this.track(new PricingPlansViewed(properties), options);
  }

  /**
   * Profile Creation Started
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/meinunterricht/meinUnterricht%20tracking%20plan/events/main/latest/Profile%20Creation%20Started)
   *
   * When the user has clicked on the Start button on the first screen of the profile creation flow (after clicking on the email confirmation link from the email)
   *
   * Owner: thomas@kasva.io
   *
   * @param options Amplitude event options.
   */
  profileCreationStarted(
    options?: EventOptions,
  ) {
    return this.track(new ProfileCreationStarted(), options);
  }

  /**
   * Role Selected
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/meinunterricht/meinUnterricht%20tracking%20plan/events/main/latest/Role%20Selected)
   *
   * When the user has selected their respective roles
   *
   * @param properties The event's properties (e.g. role)
   * @param options Amplitude event options.
   */
  roleSelected(
    properties?: RoleSelectedProperties,
    options?: EventOptions,
  ) {
    return this.track(new RoleSelected(properties), options);
  }

  /**
   * School License Upgrade Requested
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/meinunterricht/meinUnterricht%20tracking%20plan/events/main/latest/School%20License%20Upgrade%20Requested)
   *
   * Indicates a user initiated a request to upgrade the school's subscription plan, signaling intent to upgrade from either Pro or meinFortbildung to 360.
   *
   * @param properties The event's properties (e.g. school id)
   * @param options Amplitude event options.
   */
  schoolLicenseUpgradeRequested(
    properties: SchoolLicenseUpgradeRequestedProperties,
    options?: EventOptions,
  ) {
    return this.track(new SchoolLicenseUpgradeRequested(properties), options);
  }

  /**
   * School Name Selected
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/meinunterricht/meinUnterricht%20tracking%20plan/events/main/latest/School%20Name%20Selected)
   *
   * When the user has searched for and selected the school they are teaching at
   *
   * @param properties The event's properties (e.g. school name)
   * @param options Amplitude event options.
   */
  schoolNameSelected(
    properties?: SchoolNameSelectedProperties,
    options?: EventOptions,
  ) {
    return this.track(new SchoolNameSelected(properties), options);
  }

  /**
   * School Selected
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/meinunterricht/meinUnterricht%20tracking%20plan/events/main/latest/School%20Selected)
   *
   * When the user has selected the type of school he teaches at
   *
   * Owner: thomas@kasva.io
   *
   * @param options Amplitude event options.
   */
  schoolSelected(
    options?: EventOptions,
  ) {
    return this.track(new SchoolSelected(), options);
  }

  /**
   * School Stage Selected
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/meinunterricht/meinUnterricht%20tracking%20plan/events/main/latest/School%20Stage%20Selected)
   *
   * The school stage (schulstufe) the user has selected
   *
   * @param properties The event's properties (e.g. school stage)
   * @param options Amplitude event options.
   */
  schoolStageSelected(
    properties?: SchoolStageSelectedProperties,
    options?: EventOptions,
  ) {
    return this.track(new SchoolStageSelected(properties), options);
  }

  /**
   * Search Completed
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/meinunterricht/meinUnterricht%20tracking%20plan/events/main/latest/Search%20Completed)
   *
   * Event indicating a search has been completed and logs the amount of search results
   *
   * @param properties The event's properties (e.g. app section)
   * @param options Amplitude event options.
   */
  searchCompleted(
    properties: SearchCompletedProperties,
    options?: EventOptions,
  ) {
    return this.track(new SearchCompleted(properties), options);
  }

  /**
   * Search Filter Applied
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/meinunterricht/meinUnterricht%20tracking%20plan/events/main/latest/Search%20Filter%20Applied)
   *
   * When the user applied a new filter to the search by adding or removing a filter
   *
   * Owner: ahmed@meinunterricht.de
   *
   * @param properties The event's properties (e.g. app section)
   * @param options Amplitude event options.
   */
  searchFilterApplied(
    properties: SearchFilterAppliedProperties,
    options?: EventOptions,
  ) {
    return this.track(new SearchFilterApplied(properties), options);
  }

  /**
   * Search Submitted
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/meinunterricht/meinUnterricht%20tracking%20plan/events/main/latest/Search%20Submitted)
   *
   * When the user submitted a new search
   *
   * Owner: ahmed@meinunterricht.de
   *
   * @param properties The event's properties (e.g. app section)
   * @param options Amplitude event options.
   */
  searchSubmitted(
    properties: SearchSubmittedProperties,
    options?: EventOptions,
  ) {
    return this.track(new SearchSubmitted(properties), options);
  }

  /**
   * State Selected
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/meinunterricht/meinUnterricht%20tracking%20plan/events/main/latest/State%20Selected)
   *
   * When the user has selected their respective state
   *
   * @param properties The event's properties (e.g. state)
   * @param options Amplitude event options.
   */
  stateSelected(
    properties?: StateSelectedProperties,
    options?: EventOptions,
  ) {
    return this.track(new StateSelected(properties), options);
  }

  /**
   * Subjects Classified
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/meinunterricht/meinUnterricht%20tracking%20plan/events/main/latest/Subjects%20Classified)
   *
   * When the user has further classified which of the previously selected subjects are main and minor subjects that he teaches
   *
   * Owner: thomas@kasva.io
   *
   * @param options Amplitude event options.
   */
  subjectsClassified(
    options?: EventOptions,
  ) {
    return this.track(new SubjectsClassified(), options);
  }

  /**
   * Subjects Selected
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/meinunterricht/meinUnterricht%20tracking%20plan/events/main/latest/Subjects%20Selected)
   *
   * When the user has selected the subject(s) that are relevant to him during profile creation
   *
   * Owner: Daniel Siebenson
   *
   * @param options Amplitude event options.
   */
  subjectsSelected(
    options?: EventOptions,
  ) {
    return this.track(new SubjectsSelected(), options);
  }

  /**
   * Subscription Cancellation Selected
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/meinunterricht/meinUnterricht%20tracking%20plan/events/main/latest/Subscription%20Cancellation%20Selected)
   *
   * When a subscriber confirms that he wants to proceed with cancelling his subscription in the cancellation flow
   *
   * Owner: thomas@kasva.io
   *
   * @param properties The event's properties (e.g. page source)
   * @param options Amplitude event options.
   */
  subscriptionCancellationSelected(
    properties: SubscriptionCancellationSelectedProperties,
    options?: EventOptions,
  ) {
    return this.track(new SubscriptionCancellationSelected(properties), options);
  }

  /**
   * Subscription Cancellation Viewed
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/meinunterricht/meinUnterricht%20tracking%20plan/events/main/latest/Subscription%20Cancellation%20Viewed)
   *
   * When a subscriber views the subscription cancellation flow
   *
   * Owner: thomas@kasva.io
   *
   * @param properties The event's properties (e.g. trial)
   * @param options Amplitude event options.
   */
  subscriptionCancellationViewed(
    properties: SubscriptionCancellationViewedProperties,
    options?: EventOptions,
  ) {
    return this.track(new SubscriptionCancellationViewed(properties), options);
  }

  /**
   * Subscription Pause Selected
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/meinunterricht/meinUnterricht%20tracking%20plan/events/main/latest/Subscription%20Pause%20Selected)
   *
   * When a subscriber selects that he wants to pause the current subscription during the cancellation flow
   *
   * Owner: thomas@kasva.io
   *
   * @param properties The event's properties (e.g. page source)
   * @param options Amplitude event options.
   */
  subscriptionPauseSelected(
    properties?: SubscriptionPauseSelectedProperties,
    options?: EventOptions,
  ) {
    return this.track(new SubscriptionPauseSelected(properties), options);
  }

  /**
   * Subscription Pause Submitted
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/meinunterricht/meinUnterricht%20tracking%20plan/events/main/latest/Subscription%20Pause%20Submitted)
   *
   * When a subscriber submits the confirmation that he wants to pause the current subscription
   *
   * Owner: thomas@kasva.io
   *
   * @param properties The event's properties (e.g. pause duration)
   * @param options Amplitude event options.
   */
  subscriptionPauseSubmitted(
    properties: SubscriptionPauseSubmittedProperties,
    options?: EventOptions,
  ) {
    return this.track(new SubscriptionPauseSubmitted(properties), options);
  }

  /**
   * Subscription Submitted
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/meinunterricht/meinUnterricht%20tracking%20plan/events/main/latest/Subscription%20Submitted)
   *
   * When the user has submitted the required information for starting the subscription
   *
   * Owner: thomas@kasva.io
   *
   * @param properties The event's properties (e.g. billing cycle)
   * @param options Amplitude event options.
   */
  subscriptionSubmitted(
    properties: SubscriptionSubmittedProperties,
    options?: EventOptions,
  ) {
    return this.track(new SubscriptionSubmitted(properties), options);
  }

  /**
   * Teacher Added
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/meinunterricht/meinUnterricht%20tracking%20plan/events/main/latest/Teacher%20Added)
   *
   * When an admin adds a teacher to the school
   *
   * @param properties The event's properties (e.g. school id)
   * @param options Amplitude event options.
   */
  teacherAdded(
    properties: TeacherAddedProperties,
    options?: EventOptions,
  ) {
    return this.track(new TeacherAdded(properties), options);
  }

  /**
   * Teacher Invite Resent
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/meinunterricht/meinUnterricht%20tracking%20plan/events/main/latest/Teacher%20Invite%20Resent)
   *
   * Triggered when a school administrator resends an invitation to a teacher to join the platform.
   *
   * @param properties The event's properties (e.g. school id)
   * @param options Amplitude event options.
   */
  teacherInviteResent(
    properties: TeacherInviteResentProperties,
    options?: EventOptions,
  ) {
    return this.track(new TeacherInviteResent(properties), options);
  }

  /**
   * Teacher Removed
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/meinunterricht/meinUnterricht%20tracking%20plan/events/main/latest/Teacher%20Removed)
   *
   * Event has no description in tracking plan.
   *
   * @param properties The event's properties (e.g. school id)
   * @param options Amplitude event options.
   */
  teacherRemoved(
    properties: TeacherRemovedProperties,
    options?: EventOptions,
  ) {
    return this.track(new TeacherRemoved(properties), options);
  }

  /**
   * Text Edited
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/meinunterricht/meinUnterricht%20tracking%20plan/events/main/latest/Text%20Edited)
   *
   * When the user edits ≥ 1 while the editor is opened (only triggers once)
   *
   * @param properties The event's properties (e.g. conversation id)
   * @param options Amplitude event options.
   */
  textEdited(
    properties: TextEditedProperties,
    options?: EventOptions,
  ) {
    return this.track(new TextEdited(properties), options);
  }

  /**
   * Text Editor File Exported
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/meinunterricht/meinUnterricht%20tracking%20plan/events/main/latest/Text%20Editor%20File%20Exported)
   *
   * When the user exports (downloads, prints, shares) a file
   *
   * @param properties The event's properties (e.g. content)
   * @param options Amplitude event options.
   */
  textEditorFileExported(
    properties: TextEditorFileExportedProperties,
    options?: EventOptions,
  ) {
    return this.track(new TextEditorFileExported(properties), options);
  }

  /**
   * Text Editor Opened
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/meinunterricht/meinUnterricht%20tracking%20plan/events/main/latest/Text%20Editor%20Opened)
   *
   * When a user opens the text editor
   *
   * @param properties The event's properties (e.g. conversation id)
   * @param options Amplitude event options.
   */
  textEditorOpened(
    properties: TextEditorOpenedProperties,
    options?: EventOptions,
  ) {
    return this.track(new TextEditorOpened(properties), options);
  }

  /**
   * Video Unlocked
   *
   * [View in Tracking Plan](https://data.eu.amplitude.com/meinunterricht/meinUnterricht%20tracking%20plan/events/main/latest/Video%20Unlocked)
   *
   * When the user has unlocked any video for pupils
   *
   * @param properties The event's properties (e.g. content)
   * @param options Amplitude event options.
   */
  videoUnlocked(
    properties?: VideoUnlockedProperties,
    options?: EventOptions,
  ) {
    return this.track(new VideoUnlocked(properties), options);
  }
}

export const ampli = new Ampli();

// BASE TYPES
type BrowserOptions = amplitude.Types.BrowserOptions;

export type BrowserClient = amplitude.Types.BrowserClient;
export type BaseEvent = amplitude.Types.BaseEvent;
export type IdentifyEvent = amplitude.Types.IdentifyEvent;
export type GroupEvent = amplitude.Types.GroupIdentifyEvent;
export type Event = amplitude.Types.Event;
export type EventOptions = amplitude.Types.EventOptions;
export type Result = amplitude.Types.Result;
